import type { ColumnInfo } from '@townsquare/columns/types';
import { tqlQueryFromInput } from '@townsquare/tql/query';
import { ComparatorOperator } from '@townsquare/tql/types';
import type { User } from '@townsquare/user-store/types';

const SHOW_EMPTY_TEAMS_KEY = 'showEmptyTeams';
export const appendEmptyTeamSearchToTql = (tql: string): string => {
	if (tql.includes(SHOW_EMPTY_TEAMS_KEY)) {
		return tql;
	}
	return `${tql.length > 0 ? `(${tql}) AND ` : ''}(${SHOW_EMPTY_TEAMS_KEY} = true)`;
};

export const updateTeamQueryBasedOnScreen = (tql: string, screen: string, user: User): string => {
	if (screen === 'YOUR_TEAMS') {
		const memberQuery = `(member = ${user.accountId})`;
		return tql ? `${tql} AND ${memberQuery}` : memberQuery;
	}
	return tql;
};

export function getTeamColumnsToFetchInTql(columns: ColumnInfo[]): {
	includeGoals: boolean;
	includeProjects: boolean;
} {
	return {
		includeGoals: columns.some((column) => column.id === 'teamGoals'),
		includeProjects: columns.some((column) => column.id === 'teamProjects'),
	};
}

export const defaultEmptyTeamsTql: string = tqlQueryFromInput({
	input: [
		{
			fieldName: SHOW_EMPTY_TEAMS_KEY,
			fieldValue: true,
			comparator: ComparatorOperator.EQUALS,
		},
	],
});
